<!-- Step 1: Status Selection -->
<div *ngIf="!showForm" class="status-selection-container">
  <h5 class="text-center mb-4">Bạn muốn cho học sinh</h5>

  <div class="row justify-content-center">
    <div class="col-12">
      <div class="status-buttons">
        <button *ngFor="let status of availableStatuses" 
                type="button"
                class="status-button"
                [style.border-color]="status.Color"
                (click)="selectStatus(status.Id)">
          <i [class]="status.Icon" [style.color]="status.Color"></i>
          <span>{{status.Ten}}</span>
        </button>
      </div>
    </div>
  </div>

  <div class="text-center mt-3">
    <small class="text-muted">
      Trạng thái hiện tại: 
      <strong *ngIf="trangthai == 1" class="text-success">Đang học</strong>
      <strong *ngIf="trangthai == 0" class="text-danger">Nghỉ học</strong>
      <strong *ngIf="trangthai == 2" class="text-warning">Tạm nghỉ</strong>
    </small>
  </div>
</div>

<!-- Step 2: Form Input (only show after selecting status) -->
<div *ngIf="showForm">
  <!-- Header showing selected status -->
  <div class="alert alert-info mb-3">
    <strong>Cho học sinh:</strong> 
    <span *ngIf="selectedNewStatus == 0" class="badge badge-danger ml-2">Nghỉ học</span>
    <span *ngIf="selectedNewStatus == 1" class="badge badge-success ml-2">Đi học lại</span>
    <span *ngIf="selectedNewStatus == 2" class="badge badge-warning ml-2">Tạm nghỉ</span>
    <button type="button" class="btn btn-sm btn-link float-right" (click)="showForm = false; selectedNewStatus = null">
      <i class="fas fa-edit"></i> Chọn lại
    </button>
  </div>

  <div class="row form-group">
    <label class="control-label col-4">{{'Lý do' | translate}}<span class="cred">(*)</span></label>
    <div class="col-8 required-field">
      <textarea type="text" tabindex="1" class="form-control" rows="3" [(ngModel)]="doituongSelect.LyDo"></textarea>
    </div>
  </div>

  <div class="form-group row">
    <label class="control-label col-4">{{'Ngày' | translate}}<span class="cred">(*)</span></label>
    <div class="col-8">
      <kendo-dateinput tabindex="2" style="width:100%;" [format]="'dd/MM/yyyy'" [(value)]="doituongSelect.NgayNhap"></kendo-dateinput>
    </div>
  </div>

  <div class="row form-group">
    <label class="control-label col-4">{{'Ghi chú' | translate}}</label>
    <div class="col-8 required-field">
      <textarea type="text" tabindex="3" class="form-control" rows="3" [(ngModel)]="doituongSelect.GhiChu"></textarea>
    </div>
  </div>

  <div class="row form-group">
    <label class="control-label col-4 ng-binding">Người tạo</label>
    <div class="col-8">
      <input type="text" tabIndex="4" class="form-control" placeholder="" disabled="disabled" [(ngModel)]="doituongSelect.CreatedBy">
    </div>
  </div>
</div>

<div class="modal-footer" style="display: flex;justify-content: space-between;">
  <div style="display:flex;">

  </div>
  <div class="">
    <button class="mb-1 mr-1 btn btn-secondary" (click)="closeModal()" title="Ấn ESC để thoát" style="padding-top:0px !important">Hủy bỏ</button>
    <button *ngIf="showForm" type="submit" (click)="ThucHien()" title="Ấn F9 để lưu" class="mb-1 mr-1 btn btn-primary" style="padding-top:0px !important">Lưu lại</button>
  </div>
</div>
